var React = require('react');

function FullScreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.3,10.3H0V16h5.7v-2.3H2.3V10.3z M0,5.7h2.3V2.3h3.4V0H0V5.7z M13.7,13.7h-3.4V16H16v-5.7h-2.3V13.7z M10.3,0v2.3h3.4v3.4\n\tH16V0H10.3z","fill":"currentColor"}));
}

FullScreen.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = FullScreen;

FullScreen.default = FullScreen;
